import React, { useEffect, useState } from 'react';
import { locales } from '../../translations/locales';
import BtnStatus from '../modrp/configuration/status/BtnStatus';
import { _$ } from '../../controllers/dom';

const ModalSgoModifyStart = (props) => {
    const { locale, buildings, listStatus, mission, ModuleRP, vehicleModels } = props;
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const addToStart = (vehicleId) => {
        ModuleRP.addToStart(selectedBuilding, vehicleId, mission.id, _$(`${vehicleId}`).value);
        setSelectedVehicle(false);
    };

    useEffect(() => {
    }, [buildings]);

    return (
        <div
            className="modal"
            id="modalRp"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
            aria-labelledby="modalTitle"
            aria-hidden="true"
        >
            <div className='modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <h5 className='modal-title' id='modalRpTitle'>
                            {locales[locale].sgo.manageVehiclesToSend}
                        </h5>
                        <button type='button' className='close' data-dismiss='modal' aria-label='Close' id='modalRpClose'>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div className='modal-body text-center' id='modalRp-body'>
                        <div className='row'>
                            <div className='col-3 text-left border-right border-solid border-secondary'>
                                {
                                    buildings.map((building, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className={`btn btn-${selectedBuilding === building.id ? 'success' : 'secondary'} btn-sm m-1`}
                                                onClick={() => setSelectedBuilding(building.id)}
                                            >
                                                <span>{building.name}</span>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <div className='col-5 p-0 m-0 text-left border-right border-solid border-secondary'>
                                {
                                    selectedBuilding ? (
                                        buildings.find((building) => building.id === selectedBuilding).vehicles.map((vehicle, index) => {
                                            if (
                                                vehicle.status === listStatus.find((s) => s.system === 'ONCALL').code ||
                                                (vehicle.status === listStatus.find((s) => s.system === 'SELECTED').code && vehicle.missionId === mission.id) ||
                                                (vehicle.status === listStatus.find((s) => s.system === 'RETURN').code && vehicle.missionId !== mission.id)
                                            ) {
                                                return (
                                                    <div
                                                        key={index}
                                                        className='row cursor-pointer m-1'
                                                    >
                                                        <span
                                                            className='col-4 hoover-light rounded'
                                                            onClick={() => {
                                                                addToStart(vehicle.id);
                                                            }}
                                                        >
                                                            <BtnStatus
                                                                listStatus={listStatus}
                                                                code={Number(vehicle.status)}
                                                                text={`${vehicle.name}`}
                                                            />
                                                        </span>
                                                        <span
                                                            className='col-4 text-right hoover-light rounded'
                                                            onClick={() => {
                                                                setSelectedVehicle(vehicle.id);
                                                            }}
                                                        >
                                                            {listStatus.find((status) => Number(status.code) === Number(vehicle.status)).name}
                                                        </span>
                                                        <span
                                                            className='col-4 text-right'
                                                        >
                                                            {
                                                                vehicleModels.map((model, index) => {
                                                                    if (model.id === vehicle.modelId) {
                                                                        return (
                                                                            <select key={index} className='form-control' id={vehicle.id}>
                                                                                {
                                                                                    model.functions.map((fn, index) => {
                                                                                        if (
                                                                                            (
                                                                                                vehicle.status === listStatus.find(
                                                                                                    (s) => s.system === 'RETURN',
                                                                                                ).code &&
                                                                                                vehicle.armedFunction === fn.name) ||
                                                                                            vehicle.status !== listStatus.find(
                                                                                                (s) => s.system === 'RETURN',
                                                                                            ).code
                                                                                        ) {
                                                                                            return (
                                                                                                <option key={index} value={fn.name}>
                                                                                                    {fn.name}
                                                                                                </option>
                                                                                            );
                                                                                        }
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        );
                                                                    }
                                                                })
                                                            }
                                                        </span>
                                                    </div>
                                                );
                                            }
                                        })
                                    ) : null
                                }
                            </div>
                            <div className='col-4'>
                                {
                                    selectedBuilding && selectedVehicle ? (
                                        buildings.find((building) => building.id === selectedBuilding).vehicles.map((vehicle) => {
                                            if (vehicle.id === selectedVehicle) {
                                                return (
                                                    <div key={vehicle.id} className='row'>
                                                        {
                                                            vehicle.manning.map((manning, index) => {
                                                                return (
                                                                    <div key={index}>
                                                                        <span
                                                                            className={`col-6 text-left ${manning.required ? 'text-danger' : 'text-secondary'}`}
                                                                        >
                                                                            {manning.skill}
                                                                        </span>
                                                                        <span className='col-6 text-right'>
                                                                            {manning.player?.name || locales[locale].sgo.empty}
                                                                        </span>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                );
                                            }
                                        })
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer' id='modalRp-footer'>
                        <button type='button' className='btn btn-secondary' data-dismiss='modal'>
                            {locales[locale].close}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalSgoModifyStart;
